import { render } from "./TablaFamilias.vue?vue&type=template&id=39900937&ts=true"
import script from "./TablaFamilias.vue?vue&type=script&lang=ts"
export * from "./TablaFamilias.vue?vue&type=script&lang=ts"

import "./TablaFamilias.vue?vue&type=style&index=0&id=39900937&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__